import { ChevronDown } from "lucide-react";
import type { ChangeEvent, ReactNode } from "react";

export interface SelectOption {
  label: string;
  value: string;
}

export function SelectControl({
  ariaLabel,
  disabled,
  icon,
  onChange,
  options,
  value,
}: {
  ariaLabel: string;
  disabled?: boolean;
  icon?: ReactNode;
  onChange: (value: string) => void;
  options: readonly SelectOption[];
  value: string;
}) {
  return (
    <label className="relative flex min-w-0 items-center gap-2 rounded-xl border border-stone-200 bg-surface px-3 shadow-xs transition focus-within:border-emerald-700 focus-within:ring-3 focus-within:ring-emerald-700/10">
      {icon}
      <span className="sr-only">{ariaLabel}</span>
      <select
        aria-label={ariaLabel}
        className="focus-ring h-10 min-w-0 flex-1 appearance-none bg-transparent pr-7 text-sm font-semibold text-stone-800 disabled:text-stone-400"
        disabled={disabled}
        onChange={(event: ChangeEvent<HTMLSelectElement>) =>
          onChange(event.target.value)
        }
        value={value}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 size-4 text-stone-400" />
    </label>
  );
}
